import { gettingStarted } from './privateCloudBusinessEditionFactoryConfig';
export const pagesConfig = [...gettingStarted()];
